import { SagaIterator } from 'redux-saga';
import { call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { fetchStore, fetchStoresList } from '../api/store';
import {
  fetchStoreExtensions,
  makeIWSCall,
  openStoreExtensions,
  setStoreExtensions,
  setStores,
} from '../actions';
import { sortByStoreAsc } from '../utils/stores';
import { getType } from 'typesafe-actions';
import { getExtensionByStoreId } from '../reducers/extensions';
import { getQueryParam, QueryParams } from '../utils/routing';
import { getStoreIdBySloc } from '../reducers/stores';
import { SendCommand } from '../api/calls';

export function* root(): SagaIterator {
  const stores = yield call(fetchStoresList);
  yield put(setStores(sortByStoreAsc(stores)));

  yield fork(initStoreExtensions);

  const slocQueryParam = getQueryParam(QueryParams.sloc);
  if (slocQueryParam) {
    const storeId = yield select(getStoreIdBySloc(slocQueryParam));
    if (storeId) {
      yield put(fetchStoreExtensions(storeId));
    }
  }

  yield fork(initIWSCalls);
}

export function* initStoreExtensions(): SagaIterator {
  yield takeEvery(getType(fetchStoreExtensions), function*({
    payload: storeId,
  }: ReturnType<typeof fetchStoreExtensions>) {
    const extensions = yield select(getExtensionByStoreId(storeId));
    if (!extensions) {
      const storeExtensions = yield call(fetchStore, storeId);
      const storeExtensionsIndex = storeExtensions ? storeExtensions : [];
      yield put(setStoreExtensions(storeId, storeExtensionsIndex));
    } else {
      yield put(openStoreExtensions(storeId, !extensions.isOpen));
    }
  });
}

export function* initIWSCalls(): SagaIterator {
  yield takeEvery(getType(makeIWSCall), function*({ payload }: ReturnType<typeof makeIWSCall>) {
    const integrationURL = getQueryParam(QueryParams.IntegrationURL);
    if (integrationURL) {
      try {
        yield call(SendCommand, 'makecall', integrationURL, payload);
      } catch (err) {
        console.log(err.message);
      }
    }
  });
}
